import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import { OptionGrantLetter, OptionGrantLetterForm } from "./optionGrantLetterDomain";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<OptionGrantLetter>,
  data?: OptionGrantLetter,
): OptionGrantLetterForm {
  return new OptionGrantLetterForm(context, data);
}

export function isValid(form: OptionGrantLetterForm): boolean {
  return form.isValid;
}

export function validate(form: OptionGrantLetterForm): boolean {
  return form.validate();
}

export function applyForm(form: OptionGrantLetterForm): OptionGrantLetter {
  return form.toData();
}

export const optionGrantLetterHandler: DecisionTypeHandler<
  DecisionType.optionGrantLetter,
  OptionGrantLetter,
  OptionGrantLetterForm
> = {
  type: DecisionType.optionGrantLetter,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
